export const togggleLoad = () => ({ 'type': 'TOGGLE_LOAD' });